import { DepotOverview } from '@models/resources/depot.model';

/**
 * Depot-Übersicht für den Demo-Kunden (Sprint 5c S5c-9, V4).
 *
 * Vier Metalle gemäß ADR-008. Au und Ag sind aktiv (Bestand + Preise),
 * Pt und Pd sind `is_active=false` — `price_per_gram_net_eur` und
 * `value_net_eur` sind dort `null`, der Customer sieht „—" statt einer
 * Zahl. Sell-Spread (ADR-008 D1) ist bereits in den Demo-Preisen
 * eingerechnet, damit die Werte direkt das matchen, was der BE-Resource
 * `price_per_gram_net_eur` liefert.
 *
 * Wire-Shape matched `DepotOverviewResource::toArray()` 1:1.
 */
export const DEMO_DEPOT_OVERVIEW: DepotOverview = {
  depot_number: 'D-0127',
  status: 'active',
  opened_at: '2024-01-15',
  total_value_net_eur: 412_835.4,
  last_transaction_at: '2026-03-28T14:12:00+01:00',
  positions: [
    {
      metal_id: 1,
      metal_symbol: 'Au',
      metal_name: 'Gold',
      is_active: true,
      quantity_grams: 4_850.5,
      price_per_gram_net_eur: 82.08,
      value_net_eur: 398_142.9,
      price_at: '2026-05-09T17:00:00+02:00',
    },
    {
      metal_id: 2,
      metal_symbol: 'Ag',
      metal_name: 'Silber',
      is_active: true,
      quantity_grams: 12_400.0,
      price_per_gram_net_eur: 1.185,
      value_net_eur: 14_692.5,
      price_at: '2026-05-09T17:00:00+02:00',
    },
    {
      metal_id: 3,
      metal_symbol: 'Pt',
      metal_name: 'Platin',
      is_active: false,
      quantity_grams: 0,
      price_per_gram_net_eur: null,
      value_net_eur: null,
      price_at: null,
    },
    {
      metal_id: 4,
      metal_symbol: 'Pd',
      metal_name: 'Palladium',
      is_active: false,
      quantity_grams: 0,
      price_per_gram_net_eur: null,
      value_net_eur: null,
      price_at: null,
    },
  ],
};
